var exports = {
  "z": "summary__DAbosI",
  "g5": "summaryText__Fr5gjr",
  "ai": "chevron__JqD7ub",
  "ld": "items__UjtBdY",
};

module.exports = exports;
